import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { useActivePurchaseAccess } from "../../hooks/useActivePurchaseAccess";
import { useAuth } from "../../hooks/useAuth";
import { hasPermission } from "../../lib/permissions";

interface RequirePermissionProps extends PropsWithChildren {
  roles?: string[];
  forms?: string[];
  processes?: string[];
  anyOf?: Array<{
    roles?: string[];
    forms?: string[];
    processes?: string[];
  }>;
}

function resolveFallbackPath(userType: "office" | "crew" | undefined) {
  if (!userType) {
    return "/login";
  }

  return "/dashboard";
}

export function RequirePermission({ roles, forms, processes, anyOf, children }: RequirePermissionProps) {
  const { isInitialized, isLoading, user } = useAuth();
  const { user: activePurchaseUser, isLoading: isActivePurchaseAccessLoading } = useActivePurchaseAccess();
  const permissionUser = activePurchaseUser ?? user;

  if (!isInitialized || isLoading || isActivePurchaseAccessLoading) {
    return <div>Loading...</div>;
  }

  const hasDirectPermission = hasPermission(permissionUser, { roles, forms, processes });
  const hasAnyConfiguredPermission = Boolean(anyOf?.some((option) => hasPermission(permissionUser, option)));

  if (!hasDirectPermission && !hasAnyConfiguredPermission) {
    return <Navigate replace to={resolveFallbackPath(user?.type)} />;
  }

  return <>{children}</>;
}
